import { getCollections, getCollectionsComplete, getDate, cambiarTextos } from './functions';
import dayjs from 'dayjs';
let xlsx = require('json-as-xlsx');

export async function reporteUsuarios() {
  const results = await getCollections('usuarios');
  const array = Object.values(results).map((val) => ({
    uid: val.uid || '',
    nombre: val.nombre || '',
    // empresa: val.empresa || '',
    // cargo: val.cargo || '',
    cedula: val.cedula || '',
    ciudad: val.ciudad || '',
    correo: val.correo || '',
    autorizaDatos: val.autorizaDatos ? 'Sí' : 'No',
    fecha: val.fecha || '',
  }));

  const fecha = cambiarTextos(getDate());
  xlsx([{
    sheet: 'Usuarios',
    columns: [
      { label: 'UID', value: 'uid' },
      { label: 'Nombre', value: 'nombre' },
      // { label: 'Empresa', value: 'empresa' },
      // { label: 'Cargo', value: 'cargo' },
      { label: 'Cédula', value: 'cedula' },
      { label: 'Ciudad', value: 'ciudad' },
      { label: 'Correo', value: 'correo' },
      { label: 'Autoriza datos', value: 'autorizaDatos' },
      { label: 'Fecha registro', value: 'fecha' },
    ],
    content: array,
  }], { fileName: `usuarios-${fecha}`, extraLength: 3, writeOptions: {} });
}

export async function reporteChat() {
  const [dia1, dia2] = await Promise.all([
    getCollectionsComplete('chat/dia1'),
    getCollectionsComplete('chat/dia2'),
  ]);

  const mapMensajes = (data, dia) =>
    data
      ? Object.values(data).map((msg) => ({
          dia,
          idIncrement: msg.idIncrement || '',
          fechaDeRegistro: msg.fechaDeRegistro || '',
          nombre: msg.nombre || '',
          texto: msg.text || '',
          visible: msg.visible ? 'Sí' : 'No',
          user: msg.user || '',
        }))
      : [];

  const array = [...mapMensajes(dia1, 'Día 1'), ...mapMensajes(dia2, 'Día 2')];
  array.sort((a, b) => a.idIncrement - b.idIncrement);

  const now = new Date();
  xlsx([{
    sheet: 'Chat',
    columns: [
      { label: 'Día',            value: 'dia' },
      { label: '#',              value: 'idIncrement' },
      { label: 'Fecha',          value: 'fechaDeRegistro' },
      { label: 'Nombre',         value: 'nombre' },
      { label: 'Mensaje',        value: 'texto' },
      { label: 'Visible',        value: 'visible' },
      { label: 'UID usuario',    value: 'user' },
    ],
    content: array,
  }], { fileName: `chat-${now.getTime()}`, extraLength: 3, writeOptions: {} });
}

export async function reporteAsistenciaa(mes) {
  const [asistenciaBD, usuariosBD] = await Promise.all([
    getCollectionsComplete(`asistencia/${mes}`),
    getCollectionsComplete('usuarios'),
  ]);

  const array = [];
  if (asistenciaBD) {
    Object.keys(asistenciaBD).forEach((uid) => {
      const registro = asistenciaBD[uid];
      const usuario = usuariosBD?.[uid] || {};

      // Extrae todas las sesiones (claves que empiezan con "sesion_")
      const sesiones = Object.entries(registro)
        .filter(([k]) => k.startsWith('sesion_'))
        .map(([, v]) => v);

      // Calcula tiempo total conectado en minutos
      let minutosTotal = 0;
      sesiones.forEach(({ entrada, salida }) => {
        if (entrada && salida) {
          const diff = dayjs(salida, 'YYYY-MM-DD HH:mm:ss').diff(dayjs(entrada, 'YYYY-MM-DD HH:mm:ss'), 'minute');
          if (diff > 0) minutosTotal += diff;
        }
      });

      // Itera por cada fecha (targetDate) dentro del uid
      Object.entries(registro).forEach(([fecha, val]) => {
        if (typeof val !== 'object' || !val.diaEvento) return;
        array.push({
          diaEvento: val.diaEvento || fecha,
          primeraEntrada: val.primeraEntrada || '',
          timezone: val.timezone || '',
          sesiones: sesiones.length,
          minutosConectado: minutosTotal,
          mensajesChat: val.mensajesChat || 0,
          nombre: usuario.nombre || '',
          // empresa: usuario.empresa || '',
          // cargo: usuario.cargo || '',
          cedula: usuario.cedula || '',
          ciudad: usuario.ciudad || '',
          correo: usuario.correo || '',
        });
      });
    });
  }

  const now = new Date();
  xlsx([{
    sheet: 'Asistencia',
    columns: [
      { label: 'Día del evento',     value: 'diaEvento' },
      { label: 'Primera entrada',    value: 'primeraEntrada' },
      { label: 'Zona horaria',       value: 'timezone' },
      { label: 'Veces que entró',    value: 'sesiones' },
      { label: 'Minutos conectado',  value: 'minutosConectado' },
      { label: 'Mensajes en chat',   value: 'mensajesChat' },
      { label: 'Nombre',             value: 'nombre' },
      // { label: 'Empresa',            value: 'empresa' },
      // { label: 'Cargo',              value: 'cargo' },
      { label: 'Cédula',            value: 'cedula' },
      { label: 'Ciudad',              value: 'ciudad' },
      { label: 'Correo',             value: 'correo' },
    ],
    content: array,
  }], { fileName: `asistencia-${mes}-${now.getTime()}`, extraLength: 3, writeOptions: {} });
}
